import React, { Suspense } from 'react';

export default function RouteLoadFallback({ label = 'Loading…' }) {
  return (
    <div className="route-load-fallback" role="status" aria-live="polite">
      <div className="route-load-fallback__spinner" aria-hidden />
      <span>{label}</span>
    </div>
  );
}

export function lazyRoute(importFn, label) {
  const Lazy = React.lazy(importFn);
  return function LazyRoute(props) {
    return (
      <Suspense fallback={<RouteLoadFallback label={label} />}>
        <Lazy {...props} />
      </Suspense>
    );
  };
}
